<template>
	<div class="inquiry" style="width: 1200px; margin: auto" >
		<!-- 面包屑导航 -->
		<el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
			<!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>限时折扣</el-breadcrumb-item> -->
			<el-breadcrumb-item style="cursor: pointer" @click.native="breadcrumbClick(item.id, index, item)"
				v-for="(item, index) in breadcrumbList" :key="item.id">{{ item.name }}</el-breadcrumb-item>
			<el-breadcrumb-item v-if="breadcrumbList.length == 1 ? true : false">询价</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="title">询价信息
	
			<div class="btnList">
		<div class='excalBtn' >
				  <a href="./static/enquiryTemplate.xlsx" download="询价模板" target="downloadFile">Excel询价表格下载</a>
		</div>
		<div class="uploadingBtn">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
					<el-form-item label="" prop="avatar">
						<el-upload name="files" class="avatar-uploader"
						multiple
						:limit="5"
						  :on-exceed="handleExceed"
							:action="`${$baseUrl}/common/file/upload`"
							accept="image/jpeg,application/pdf,image/png,application/vnd.ms-works,application/vnd.ms-works,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword "
							:on-success="handleAvatarSuccess" :on-remove="handleRemove" :before-upload="beforeAvatarUpload">
							<el-button class="btn" size="small" type="primary">上传询价文件</el-button>
							<div slot="tip" class="el-upload__tip">上传文件不超过2MB</div>
							<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
						</el-upload>
						<span  class="dialog-footer">
						        <el-button class="btn" type="primary" size="default" :disabled="!fileList.length" @click="submitUpload('ruleForm')">确定</el-button>
						      </span>
						
					</el-form-item>
				</el-form>
			
			 <!-- <input type="file"
			                  @change="addFile"
			                  ref="inputer"
							  multiple="multiple"
			                  accept="image/jpeg,application/pdf,image/png,application/vnd.ms-works,application/vnd.ms-works,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword "
			                >
			上传询价文件 -->
		
		
		</div>
	</div>
		</div>
		<div class="formData">
			<el-form ref="form" :model="formInline" label-width="130px" :rules='rules'>
				<el-form-item label="项目名称">
					<div class="project">
						<el-input size="small" v-model="formInline.projectName" placeholder="项目名称"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="收货地址" prop="addressId" >
					<el-input size="small" v-model="formInline.address" placeholder="请输入收货地址"></el-input>
					<!-- <el-cascader
					ref="cascader"
					size="small"
					v-model="formInline.addressId"
					:options="options"
					@change="handleChange($event)"
					style="display:block;"
				  ></el-cascader> -->
				</el-form-item>
				<!-- <el-form-item label="详细地址" prop="address">
					<el-input size="small" v-model="formInline.address" placeholder="请输入收货详细地址"></el-input>
				</el-form-item> -->
				<el-form-item label="公司名称">
					<div class="name">
						<el-input size="small" v-model="formInline.companyName" placeholder="请输入公司名称"></el-input>
					</div>
				</el-form-item>
				<div class="user">
					<el-form-item label="联系人" prop="contact">
						<el-input size="small" v-model="formInline.contact" placeholder="请输入联系人"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="contactPhone">
						<el-input size="small" v-model="formInline.contactPhone" placeholder="请输入联系人"></el-input>
					</el-form-item>
					<!-- <el-form-item label="要求到货日期">
            <el-date-picker
              size="small"
              v-model="value1"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item> -->
				</div>
				<el-form-item label="其他说明">
					<div class="explain">
						<el-input v-model="formInline.remark" type="textarea" :rows="2" placeholder="请输入内容">
						</el-input>
					</div>
				</el-form-item>
				<div class="commoditList">
					<div class="shop">商品清单</div>
					<!-- <div class="import" @click="getImport">批量导入</div>
                    <div class="importPhoto">上传清单(照片,文档,表格)</div> -->
				</div>
				<br />
				<div class="tableAdd">
					<el-table align="center" :data="formInline.list">
						<!-- <el-table-column label="序号" width="90px">
              <template slot-scope="scope">
                {{ scope.row.id }} 
              </template>
            </el-table-column> -->
						<el-table-column label="商品名称(助记码)" width="230px" prop="skuName">
							<!-- <template slot-scope="scope"> -->
								<!-- <div class="goodsName" @click="selectBn(scope.$index)">{{scope.row.skuName==''?'请选择商品':scope.row.skuName}}</div> -->
							<!-- <el-input v-model="scope.row.skuName" placeholder="请选择商品" disabled></el-input> -->
								<!-- <el-select filterable @change="(v) => onChange(v, scope.row)"
									v-model="scope.row.skuName" placeholder="请选择">
									<el-option v-for="item in shopSelect" :key="item.name" :label="item.name"
										:value="item.name">
									</el-option>
								</el-select> -->
							<!-- </template> -->
							
							<template slot-scope="scope">
								<div class='shopName'>
									<!-- <img :src="scope.row.logoUrl" alt="" v-if="scope.row.logoUrl"> -->
									<el-input :disabled='scope.row.isHidden' @change="changeList(scope.$index)"
										v-model="scope.row.name" placeholder="请输入内容" data-id="11">
									</el-input>
									<!-- <div>{{ scope.row.name }}</div> -->
									<div class="moreBn" v-if="scope.row.total>1" @click="selectBn(scope.$index)">
										找到：{{scope.row.total}}</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="brandName" label="品牌">
							<template slot-scope="scope">
								<el-input v-model="scope.row.brandName" placeholder="请输入内容"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="商品描述" width="200px" align="center" prop="remark">
							<template slot-scope="scope">
								<el-input v-model="scope.row.remark" placeholder="请输入内容"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="price" label="单价"> </el-table-column>
						<el-table-column prop="number" label="数量">
							<template slot-scope="scope">
								<el-input :min="0" v-model="scope.row.number" type="number"
									placeholder="请输入内容"></el-input>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="name" label="单位" width="90px">
              <template slot-scope="scope">
                <el-autocomplete
                  class="inline-input"
                  v-model="scope.row.company"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  @select="handleSelect"
                >
                </el-autocomplete>
              </template>
            </el-table-column> -->
						<el-table-column width="80px" label="小计" prop="count">
							<template slot-scope="scope">
								<span>{{ scope.row.price * scope.row.number }}</span>
							</template>
						</el-table-column>
						<el-table-column label="要求到货时间" prop="arrivalTime">
							<template slot-scope="scope">
								<el-date-picker size="small" v-model="scope.row.arrivalTime" type="datetime"
									placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss">
								</el-date-picker>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="280px" align="center" fixed="right">
							<template slot-scope="scope">
								<div class="operation">
									<div @click="getDetails(scope.row)">查看详情</div>
									<div @click="removeShop(scope.$index)">
										删除
									</div>
									<!-- <div>{{scope}}</div> -->
									<div class="addShop" @click="addPurchase(scope.row, scope.$index)">
										加入采购单
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="continue">
					<div class="continueAdd" @click="addShop">+继续添加商品</div>
					<div class="continueJoin">
						<!-- <div class="matching">已匹配商品加入采购单</div> -->
						<div class="submit" @click="postAddShop('form')">提交询价单</div>
					</div>
				</div>
			</el-form>
		</div>
		<el-dialog title="上传附件" :visible.sync="dialogVisible" width="33%">
			<div class="upload">
				<div class="uploadFir">第一步:<span>下载Excel模板</span></div>
				<div class="uploadSec">
					第二步:<span>选择文件</span><em>说明:通过下载模板，将信息款速导入，可以大量缩短报价时间哦~</em>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</span>
		</el-dialog>
		
		<!-- 商品选择框 -->
		<el-dialog title="选择商品" id="pagesRow" :visible.sync="centerDialogVisible" width="40%"  center>
			<span style="font-size: 16px;line-height: 28px;">查找到{{selectList.length}}条商品信息，请选择</span>
			<ul class="pupGoodsList" v-loading="loading">
				<li class="goodsSon" v-for="(item , index) in selectList" :key="index">
					<input type="radio" name="goods" @click="radioBn(index)" />
					<span>{{item.name}}</span>
				</li>
			</ul>
			<div id="pagesbox" class="pagesRow" style="text-align: center;padding-top:10px;"></div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	let arr = 0
	import axios from "axios";
	import {
		addShoppingCart,
		pcCommoditylist,
		uploadingFeil,
		uploadContract,
		shoppingCartlist,
		quicklyModuleGet,
		myEnquiryDetail
	} from "@/api/xunyou";
	export default {
		data() {
			return {
				userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
				breadcrumbList: [{
					id: 1,
					name: "首页",
					url: "/"
				}, {
					id: 0,
					name: "所有",
					url: "/limitDiscounts"
				}], //面包屑数组
				dialogVisible: false,
				restaurants: [],
				state1: "",
				input: "",
				number: 0,
				tableData: [
				],
				value1: "",
				radio: "1",
				value: [],
				options: [],
				shopSelect: [],
				shopObj: {},
				allSelect: [],
				priceId:'',
				formInline: {
					list: [{
						arrivalTime: "",
						brandId: 0,
						brandName: "",
						count: 0,
						fileName: "",
						number: 0,
						price: 0,
						projectId: 0,
						projectName: "",
						projectType: 0,
						skuId: 0,
						skuName: "",
						isHidden:false,
						name: '',
						id:'',
						goodsList: [], //查找到商品list
						code:''
					}, ],
				},
				rules: {
					// addressId: [{
					// 	required: true,
					// 	message: '请选择收货地址',
					// 	trigger: 'change'
					// }],
					address: [{
						required: true,
						message: '请输入收货详情地址',
						trigger: 'blur'
					}],
					contact: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					contactPhone: [{
						required: true,
						message: '请输入联系人电话',
						trigger: 'blur'
					}],
				},
				urlImg: '',
				formData: new FormData(),
				file: {}, //文件数据  
				ruleForm: {
					

				},
				fileList:[],
				centerDialogVisible: false, //商品弹窗
				selectList: [],
				selectListIndex: '', //选择商品的角标
				pageValue: 1,
				currPage:'',
				pageSize: 10,
				total:0,
				enquiryIndex:0,       //选择商品所在角标
				loading:false
			};
		},
		computed: {
			getCount() {
				return (row) => {
					return row.count * row.number;
				};
			},
		},
		mounted() {
			this.restaurants = this.loadAll();
			this.options = this.$store.state.getprovince;
		},
		created() {
			this.priceId = this.$route.query.id
			// this.getList()
			console.log(this.priceId);
			if(this.priceId){
				this.getInquiry()
			}
		},
		methods: {
			addList() {
				this.allSelect = []
				this.formInline.list.forEach(item => {
					this.formInline.list.push(item.code)
				});
			},
			changeList(index, e) { //模糊查询商品名称
			console.log(index);
			console.log(e);
				if (this.formInline.list[index].isHidden) { //已经查找过数据，重复查找会清空商品选项
					return false;
				}
				let obj = {
					pageSize: this.pageSize,
					name: this.formInline.list[index].name,
					pageNum: 1,
					userId: this.userInfo.userId || ''
				};
				console.log(obj);
				quicklyModuleGet(obj).then(res => {
					if (res.rows[0]) {
						let newArr = false;
						newArr = this.formInline.list.findIndex(item => item.code == res.rows[0].id)
						console.log("已存在",newArr);
						// if (this.tableData[newArr].isHidden) {
						// if (newArr > -1) {
						// 	this.$message({
						// 		message: '已存在商品，数量+1',
						// 		type: 'warning'
						// 	});
						// 	this.formInline.list[newArr].num++
						// 	this.formInline.list.splice(this.tableData.length - 1, 1)
						// } else {
						if(res.rows.length ==1 ){
							console.log('图片2' + res.rows[0].more_photos.split(',')[0]);
							const arr = {
								id: this.formInline.list[index].id,
								code: res.rows[0].id,
								name: res.rows[0].name,
								stock: res.rows[0].stock,
								price: res.rows[0].specificationlist[0].price || res.rows[0].price, //不存在规格时执行
								realprice: res.rows[0].specificationlist[0].price || res.rows[0].price,
								num: 1,
								number:1,
								brandName:res.rows[0].merchantName,
								remark:this.formInline.list[index].remark || '',
								arrivalTime:this.formInline.list[index].arrivalTime || '',
								logoUrl: res.rows[0].more_photos.split(',')[0],
								photos: res.rows[0].more_photos.split(',')[0],
								cid: res.rows[0].cid,
								uid: res.rows[0].uid,
								bxysid: res.rows[0].specificationlist[0].id || '', //默认第一个规格
								bxysName: res.rows[0].specificationlist[0].attributeContent || '', //默认第一个规格
								stock: res.rows[0].specificationlist[0].stock || '', //默认第一个规格
								merchantName: res.rows[0].merchantName,
								isHidden: true,
								goodsId: res.rows[0].id,
								specificationlist: res.rows[0].specificationlist,
								bxmId: res.rows[0].mid,
								goodsList: res.rows, //相似商品
								unknown: false,
								total: res.total, //商品总数
								antistop: this.formInline.list[index].name, //查找关键词
								pageValue: this.currPage, //当前页
								pageCount: Math.ceil(res.total / this.pageSize) //总页数
								// ...res.rows[0],
							}
							console.log(arr);
							console.log("角标",index);
							this.$set(this.formInline.list, index, arr)
							this.formInline.list[index].isHidden = true;
						}else{
							this.selectBn(index,2,res.rows)//去选择，接口存在多条数据直接选择
						}
			// console.log("数组",this.formInline.list);
						// this.addList()
						// this.allPrice()
					} else {
						this.$message({
							message: '请确认商品名称是否正确',
							type: 'warning'
						});
			
						const arr = {
							code: '',
							name: '',
							address: '',
							id: this.tableData[index].id,
							stock: '',
							price: '',
							num: '',
							logoUrl: '',
							isHidden: false,
							cid: '',
							uid: '',
							bxysid: '',
							merchantName: '',
							specificationlist: [],
							bxysName: '',
							bxmId: '',
							goodsList: [],
							unknown: true //未找到商品
						}
						console.log(arr)
						this.$set(this.tableData, index, arr)
					}
				})
			},
			// 分页
			paged(e) {
				console.log('分页');
				let that = this;
				layui.use(['laypage', 'layer'], function() {
					var laypage = layui.laypage
					laypage.render({
						elem: 'pagesbox', // 分页容器id
						count: e.total, //总页数
						limit: that.pageSize, //每页显示的数量
						curr: e.pageValue, //当前页
						layout: ['prev', 'page', 'count', 'next', 'skip'], //设置分页显示的内容
						jump: function(obj, first) {
							//首次不执行
							if (!first) {
								console.log(obj.curr)
								e.pageValue = obj.curr;
								that.getShopSelect(e)
							}
						}
					});
				});
			},
			selectBn(index,type,data) { //打开选择商品窗口
			if(type ==2){
				this.centerDialogVisible = true;
				this.selectList = data;
				this.selectListIndex = index;
				this.paged(this.tableData[index])
			}else{
				console.log(index);
				this.enquiryIndex = index;
				console.log("打开");
				this.centerDialogVisible = true;
				this.selectList = this.formInline.list[index].goodsList;
				console.log(this.selectList);
				this.selectListIndex = index;
				this.paged(this.formInline.list[index])
				}
			},
			radioBn(index) { //选中之后重新赋值
			let obj = {}
			// obj.price = this.selectList[index].price;
			
			// this.formInline.list[this.enquiryIndex].price = this.selectList[index].price;
			// this.formInline.list[this.enquiryIndex].projectName = this.selectList[index].name;
			// this.formInline.list[this.enquiryIndex].skuName = this.selectList[index].name;
			// this.formInline.list[this.enquiryIndex].brandName = this.selectList[index].merchantName;
			// this.formInline.list[this.enquiryIndex].cid = this.selectList[index].cid;
			// this.formInline.list[this.enquiryIndex].id = this.selectList[index].id;
			// this.formInline.list[this.enquiryIndex].number = 1;
			// console.log(this.selectList[index]);
			
			// 	this.centerDialogVisible = false;
				
				
		const arr = {
			id: this.selectList[index].id,
			code: this.selectList[index].id,
			name: this.selectList[index].name,
			skuName : this.selectList[index].name,
			projectName:this.selectList[index].name,
			brandName :this.selectList[index].merchantName,
			stock: this.selectList[index].stock,
			price: this.selectList[index].specificationlist[0].price || this.selectList[index]
				.price, //不存在规格时执行
			realprice: this.selectList[index].specificationlist[0].price || this.selectList[index].price,
			num: 1,
			logoUrl: this.selectList[index].more_photos.split(',')[0],
			photos: this.selectList[index].more_photos.split(',')[0],
			cid: this.selectList[index].cid,
			uid: this.selectList[index].uid,
			bxysid: this.selectList[index].specificationlist[0].id || '', //默认第一个规格
			bxysName: this.selectList[index].specificationlist[0].attributeContent || '', //默认第一个规格
			stock: this.selectList[index].specificationlist[0].stock || '', //默认第一个规格
			merchantName: this.selectList[index].merchantName,
			isHidden: true,
			goodsId: this.selectList[index].id,
			specificationlist: this.selectList[index].specificationlist,
			bxmId: this.selectList[index].mid,
			goodsList: [], //相似商品
			unknown: false,
			number:1,
			remark:this.formInline.list[this.enquiryIndex].remark || '',
			arrivalTime:this.formInline.list[this.enquiryIndex].arrivalTime || ''
		}
		this.$set(this.formInline.list, this.selectListIndex, arr)
		this.centerDialogVisible = false;
			},
			handleRemove(file, fileList){
				console.log(file);
				console.log(fileList);
				this.fileList.forEach( (item , index ) => {
					console.log( item, index )
					if(item.originalFileName == file.name){
						console.log('相等'+ index);
						this.fileList.splice(index,1)
					}
				})
			},
			submitUpload(ruleForm) {
					let feilsUrl = '' 
					console.log(this.fileList);
				this.fileList.forEach((item , index ) => {
					console.log( item, index )
					feilsUrl += item.url+ ',' 
				})
				  // const feilsUrl = this.fileList + "";
				   console.log(feilsUrl);
				   let obj= {}
				   obj.userId = this.userInfo.userId;
				   obj.userName = this.userInfo.userName;
				   // obj.url = feilsUrl;
				   // console.log(obj);
				  this.$refs[ruleForm].validate((valid) => {
				  	if (valid) {
				  		const data = {}
				  		const userInfo = JSON.parse(localStorage.getItem("userdata"));
				  		const inquiryUserDTO = JSON.parse(JSON.stringify(this.formInline))
				  		Reflect.deleteProperty(inquiryUserDTO, "list")
				  		inquiryUserDTO.userId = userInfo.userId
				  		inquiryUserDTO.userName = userInfo.userName
				  		
				  console.log('0001'+  feilsUrl);
				  		const submitInquiryDTO = {
				  			areaId: userInfo.areaid,
				  			type: userInfo.type,
				  			commodityList: this.formInline.list,
				  			userId: userInfo.userId,
				  			userName: userInfo.userName,
							url : feilsUrl
				  		}
				  		data.inquiryUserDTO = inquiryUserDTO
				  		data.submitInquiryDTO = submitInquiryDTO
				  
				  		console.log(data);
				  
				  
				  			axios.post('https://www.nays.com.cn/center/purchaser/inquiry/submit/inquiry/all', data)
				  				.then(res => {
				  					if (res.data.code == '0') {
				  						this.$message.success("添加成功");
										setTimeout(()=>{
											this.$router.go(0)
										},1500)
				  						
				  					} else {
				  						this.$message.warning(res.data.msg);
				  					}
				  				})
				  
				  		
				  	}
				  })
				  
				  
			    },
			
			 handleExceed(files, fileList) {
			        this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			      },
			//  上传文件内
			handleAvatarSuccess(res, file) {
				this.urlImg = URL.createObjectURL(file.raw) // 用来图片预览的
				this.fileList.push(res.data[0])
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type == 'image/jpeg' || file.type == 'image/png'||file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
				const isLt2M = file.size / 1024 / 1024 < 2;
				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传w文件大小不能超过 2MB!');
				}
				return isLt2M;
			},



			
			// 面包屑点击事件A
			breadcrumbClick(id, index, item) {
				if (id == 1) {
					// 说明是首页 文字
					this.$router.push("/");
				}

			},
			//询价订单详情 
			getInquiry() {
				console.log('获取详情');
				
				myEnquiryDetail({priceId:this.priceId}).then(res => {
					console.log("获取详情2",res);
					console.log(res.code==0);
					if(res.code== '0'){
						console.log('获取详情111');
						this.formInline = res.data.bxyInquiryUser;
						let newList = []
						for(var i =0;i<res.data.inquiryShopList.length;i++){
							let objact = {}
							objact = res.data.inquiryShopList[i];
							objact.name = res.data.inquiryShopList[i].projectName;
							objact.isHidden = true;
							newList.push(objact)
						}
						console.log(newList);
					
						this.formInline.list = newList;
						// this.formInline.list=[];
						// this.formInline.list = res.data.inquiryShopList;
						console.log("this.formInline.list",this.formInline.list);
						console.log(this.formInline.list[0].arrivalTime, 'this.formIn123line.list')
					}else{
						console.log('获取详情222');
						console.log(res.msg);
					}
				})
				
				
			},
			async getList() {
				const userInfo = JSON.parse(localStorage.getItem("userdata"));
				await axios
					.get(
						`https://www.nays.com.cn/center/purchaser/inquiry/inquiry/list?userId=${userInfo.userId}&pageNum=1&pageSize=10`
					)
					.then((res) => {
						const data = res.data;
						const list = data.data.rows.map((item) =>
							Object.assign({}, item.bxyInquiryUser, item.bxyInquiry)
						);
						let newArr = list.find(res => this.priceId == res.id)
						this.formInline = {
							projectName: newArr.projectName,
							address: newArr.address,
							contact: newArr.contact,
							contactPhone: newArr.contactPhone,
							remark: newArr.remark,
							list: []
						}
					});
				await axios
					.get(
						`https://www.nays.com.cn/center/purchaser/inquiry/inquiry/details/list?inquiryId=${this.priceId}`
					)
					.then((res) => {
						if(res.code== 0){
							const data = res.data;
							this.formInline.list = data.data.inquiryShopList
						}else{
							console.log(res.msg);
						}
							
						
					});
			},
			postAddShop(form) {
				for (let i in this.formInline.list) {
					this.formInline.list[i].projectId = this.formInline.list[i].id
				}
				console.log(this.formInline.list);
				this.$refs[form].validate((valid) => {
					if (valid) {
						const data = {}
						const userInfo = JSON.parse(localStorage.getItem("userdata"));
						const inquiryUserDTO = JSON.parse(JSON.stringify(this.formInline))
						Reflect.deleteProperty(inquiryUserDTO, "list")
						inquiryUserDTO.userId = userInfo.userId
						inquiryUserDTO.userName = userInfo.userName

						const submitInquiryDTO = {
							areaId: userInfo.areaid,
							type: userInfo.type,
							commodityList: this.formInline.list,
							userId: userInfo.userId,
							userName: userInfo.userName
						}
						data.inquiryUserDTO = inquiryUserDTO
						data.submitInquiryDTO = submitInquiryDTO

						console.log(data);

						if (this.formInline.list[0].skuName != '') {

							axios.post('https://www.nays.com.cn/center/purchaser/inquiry/submit/inquiry/all', data)
								.then(res => {
									if (res.data.code == '0') {
										this.$confirm('预计24小时内回复全部报价，已报价商品可点击”查看询价单“', '恭喜您，询价已经提交成功！', {
												cancelButtonText: '查看询价单',
										          confirmButtonText: '返回首页',
										          type: 'success',
										          center: true
										        }).then(() => {
										          this.$router.push("/")
										        }).catch(() => {
										         this.$router.push("/myprice")
										        });
									} else {

										this.$message.warning(res.data.msg);
									}
								})

						} else {

							this.$message.warning('请输入商品信息');
						}
					}
				})

			},

			addShop() {
				
				if (this.formInline.list.length == 0 || this.formInline.list[this.formInline.list.length - 1].isHidden) {
					this.formInline.list.push({
						code: '',
						name: '',
						address: '',
						id: arr++,
						stock: '',
						price: 0,
						num: '',
						logoUrl: '',
						isHidden: false,
						cid: '',
						uid: '',
						bxysid: '',
						merchantName: '',
						specificationlist: [],
						bxysName: '',
						bxmId: '',
						goodsList: [],
						unknown: false,
						arrivalTime:'',
						
						brandId: 0,
						brandName: "",
						count: 0,
						fileName: "",
						number: 0,
						projectId: 0,
						projectName: "",
						projectType: 0,
						skuId: 0,
						skuName: "",
					})
					// this.addList()
				
				
				
				
				
				} else {
					this.$message({
						message: '请输入内容',
						type: 'warning'
					});
				}
			},
			getDetails(val) {
				console.log(val);
				if (val.id) {
					let routeUrl = this.$router.resolve({
						path: "/goodsdetail",
						query: {
							id: JSON.stringify(val.id)
						}
					})
					window.open(routeUrl.href, '_blank')
				}
			},
				// 点击分页获取内容
			getShopSelect(e) {
			console.log('004');
				const userInfo = JSON.parse(localStorage.getItem("userdata"));
				let data = {};
				data.userId = userInfo.userId,
					data.stype = 2,
					data.name= e.antistop,
					data.pageNum = e.pageValue,
					data.pageSize = this.pageSize,
					// this.loading = true;	
									this.selectList= [];
									layer.load('加载中', {time: 5*1000})
									console.log(data);
									quicklyModuleGet(data).then(res => {
										layer.close(layer.index)
										if (res.rows[0]) {
											this.selectList = res.rows;
										} else {
											this.$message({
												message: '请确认商品名称是否正确',
												type: 'warning'
											});
									
											const arr = {
												code: '',
												name: '',
												address: '',
												id: this.tableData[index].id,
												stock: '',
												price: '',
												num: '',
												logoUrl: '',
												isHidden: false,
												cid: '',
												uid: '',
												bxysid: '',
												merchantName: '',
												specificationlist: [],
												bxysName: '',
												bxmId: '',
												goodsList: [],
												unknown: true //未找到商品
											}
											this.$set(this.formInline.list, index, arr)
										}
									})
					// pcCommoditylist(data)
					// .then((res) => {
					// 	  this.loading =false;	
					// 	if (res.code == 0) {
					// 		this.shopSelect = res.rows;
							
							
							
					// 		this.selectList= res.rows;
					// 		this.total = res.total;
					// 		setTimeout(()=>{
					// 			this.paged()
					// 		},1000)
					// 		console.log("商品列表");
					// 		console.log(this.shopSelect);
					// 		// 获取商品id
					// 		console.log(this.formInline);
					// 		const obj = {};
					// 		res.rows.forEach((item) => {
					// 			obj[item.name] = item;
					// 		});
					// 		this.shopObj = obj;
					// 	} else {
					// 		this.$message({
					// 			type: "info",
					// 			message: res.msg,
					// 		});
					// 	}
					// })
			},
			onChange(v, row) {
				console.log('005');
				console.log(v, row);
				const value = this.shopObj[v];
				console.log(value, 'valuevaluevalue');
				row.price = value.price;
				row.projectName = value.name
				row.cid = value.cid
				
				row.id = value.id
				row.number = 1
				row.remark = value.description.replace(/<[^<>]+>/g, "")
				row.brandName = value.merchantName
			},
			// 获取购物车
			   getshoppingCartlist(){
			       shoppingCartlist({uid:this.userInfo.userId||''})
			           .then(res => {
			           if (res.length> 0) {
			             this.$store.commit('getCartList',res)
			           }
			        })
			           .catch(err => {
			           this.$message.error('购物车查询失败，请稍后再试！')
			           })
			   },
			addPurchase(row, rowIndex) {
				console.log('加入采购---------');
				console.log(row)
				console.log(rowIndex)
				const userInfo = JSON.parse(localStorage.getItem("userdata"));
				if (row.id == null) {
					console.log('商品参数异常 ');
					return false;
				}
				if(row.projectId){   //我的询价商品进入,商品id存在时
				row.id = row.projectId
				}
				addShoppingCart({
					cid: row.id,      //商品Id
					uid: userInfo.userId,
					number: row.number,
					bxysid: 0,
				}).then((res) => {
					if (res.code == '0') {
						this.$message.success(res.msg);
						console.log('查询');
						this.getshoppingCartlist()
						// this.removeShop(rowIndex);
					}
				})
				//   getExcel().then((res) => {
				//     console.log(res.data.msg, "resssssssssssssss");
				// const blob = new Blob([res.data.msg], {
				//     type: "application/vnd.ms-excel"
				// });

				// const downloadElement = document.createElement("a");
				// const href = window.URL.createObjectURL(blob);
				// downloadElement.href = href;
				// downloadElement.download = "学生成绩.xls";
				// document.body.appendChild(downloadElement);
				// downloadElement.click();
				// document.body.removeChild(downloadElement);
				//   });
			},
			onSubmit() {
				console.log("submit!");
			},
			handleChange(value) {
				console.log(value);
				const checkedNode =  this.$refs["cascader"].getCheckedNodes();
				this.formInline.addressId = value;
				this.formInline.addressname= checkedNode[0].pathLabels;
				    console.log( checkedNode[0].data.label ) ;  //获取当前点击节点的label值
				    console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
			
			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ?
					restaurants.filter(this.createFilter(queryString)) :
					restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
					return (
						restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
						0
					);
				};
			},
			loadAll() {
				return [{
						value: "三全鲜食（北新泾店）",
						address: "长宁区新渔路144号"
					},
					{
						value: "Hot honey 首尔炸鸡（仙霞路）",
						address: "上海市长宁区淞虹路661号",
					},
					{
						value: "新旺角茶餐厅",
						address: "上海市普陀区真北路988号创邑金沙谷6号楼113",
					},
					{
						value: "泷千家(天山西路店)",
						address: "天山西路438号"
					},
					{
						value: "胖仙女纸杯蛋糕（上海凌空店）",
						address: "上海市长宁区金钟路968号1幢18号楼一层商铺18-101",
					},
					{
						value: "贡茶",
						address: "上海市长宁区金钟路633号"
					},
					{
						value: "豪大大香鸡排超级奶爸",
						address: "上海市嘉定区曹安公路曹安路1685号",
					},
					{
						value: "茶芝兰（奶茶，手抓饼）",
						address: "上海市普陀区同普路1435号",
					},
					{
						value: "十二泷町",
						address: "上海市北翟路1444弄81号B幢-107"
					},
					{
						value: "星移浓缩咖啡",
						address: "上海市嘉定区新郁路817号"
					},
					{
						value: "阿姨奶茶/豪大大",
						address: "嘉定区曹安路1611号"
					},
					{
						value: "新麦甜四季甜品炸鸡",
						address: "嘉定区曹安公路2383弄55号"
					},
					{
						value: "Monica摩托主题咖啡店",
						address: "嘉定区江桥镇曹安公路2409号1F，2383弄62号1F",
					},
					{
						value: "浮生若茶（凌空soho店）",
						address: "上海长宁区金钟路968号9号楼地下一层",
					},
					{
						value: "NONO JUICE  鲜榨果汁",
						address: "上海市长宁区天山西路119号"
					},
					{
						value: "CoCo都可(北新泾店）",
						address: "上海市长宁区仙霞西路"
					},
					{
						value: "快乐柠檬（神州智慧店）",
						address: "上海市长宁区天山西路567号1层R117号店铺",
					},
					{
						value: "Merci Paul cafe",
						address: "上海市普陀区光复西路丹巴路28弄6号楼819",
					},
					{
						value: "猫山王（西郊百联店）",
						address: "上海市长宁区仙霞西路88号第一层G05-F01-1-306",
					},
					{
						value: "南拳妈妈龙虾盖浇饭",
						address: "普陀区金沙江路1699号鑫乐惠美食广场A13",
					},
				];
			},
			handleSelect(item) {
				console.log(item);
			},
			removeShop(val) {
				//   let newArr = {
				//     date: "",
				//     name: "",
				//     content: "",
				//     id: this.tableData[val].id,
				//     price: "",
				//     num: "",
				//     company: "",
				//     endTime: "",
				//     product: "",
				//     brand: "",
				//   };
				this.formInline.list.splice(val, 1);
				//   this.$set(this.tableData, val, newArr);
			},
			getImport() {
				this.dialogVisible = true;
			},
		},
	};
</script>
<style scoped lang="less">
	.inquiry {
		max-width: 1200px;
		margin: 0 auto;

		.title {
			height: 40px;
			line-height: 40px;
			margin: 0 auto;
			padding: 10px 5px 0;
			font-size: 16px;
			border-bottom: 1px solid #d3d3d3;

			.btnList{
				float: right;
				display: inline-block;
				padding-bottom: 5px;
margin-top: -20px;
				.excalBtn {
					display: inline-block;
					padding: 0px 10px;
					font-size: 12px;
					cursor: pointer;
					background-color: #f08328;
					color: #fff;
					    line-height: 31px;
					    height: 31px;
						
					a {
						color: #fff;
					}
				}
				
				.uploadingBtn {
					width: 300px;
					display: inline-block;
					position: relative;
					z-index: 1;
					margin-left: 20px;
					.demo-ruleForm{
						.el-form-item{
							margin-bottom: 0;
						}
							
						.btn{
							border-color:#f08328;
							background-color: #f08328;
						}
						.el-upload__tip{
							line-height: 15px;
							margin-top: 0px;
						}
						
						.avatar-uploader{
							display: inline-block;
							vertical-align: top;
							/deep/.el-upload-list{
								    position: absolute;
								    top: 61px;
								    left: 0;
								background-color: #fff;
							}
						}
						.dialog-footer{
							display: inline-block;
							vertical-align: top;
							.btn{
								line-height: 31px;
								height: 31px;
								border-color:#f08328;
								background-color: #f08328;
								padding:0 20px;
							}
						}
						
						
					}
				}
			}
		}

		.formData {
			margin-top: 10px;
		}
	}

	/deep/ .el-input__inner {
		background-color: #fff;
	}

	/deep/ .project .el-input__inner {
		width: 450px;
	}

	/deep/ .name .el-input__inner {
		width: 383px;
	}

	/deep/ .explain {
		.el-textarea {
			width: 590px;
		}
	}

	/deep/ .user {
		display: flex;

		.el-input__inner {
			width: 220px;
		}

		.el-input__prefix {
			left: -39px;
		}
	}

	.tableAdd {
		margin: 0 auto;
	}
	.goodsName{
		    line-height: 17px;
		    font-size: 14px;
			display:-webkit-box; //将对象作为弹性伸缩盒子模型显示。
			-webkit-box-orient:vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
			-webkit-line-clamp:2;
	}

	.operation {
		display: flex;
		justify-content: space-around;
		font-size: 12px;

		div {
			padding: 5px 10px;
			border: 1px solid gainsboro;
			cursor: pointer;
		}

		.addShop {
			background-color: rgb(240, 131, 40);
			color: #fff;
		}
	}

	.commoditList {
		display: flex;
		font-size: 14px;
		cursor: pointer;

		.shop {
			width: 130px;
			text-align: right;
			padding: 0 12px 0 0;
		}

		.import {
			color: rgba(102, 183, 242);
		}

		.importPhoto {
			color: rgb(102, 183, 242);
			margin-left: 36px;
		}
	}

	.upload {
		.uploadFir {
			span {
				color: rgb1(74, 144, 226);
				margin-left: 20px;
			}
		}

		.uploadSec {
			margin-top: 20px;

			span {
				display: inline-block;
				padding: 3px 8px;
				color: #fff;
				background-color: rgb(240, 131, 39);
				border-radius: 5px;
				margin: 0 20px;
			}

			em {
				font-weight: none;
				color: rgba(240, 131, 39);
				font-size: 12px;
			}
		}
	}

	.continue {
		display: flex;
		background-color: rgb(238, 238, 238);
		padding: 0 0 0 30px;
		height: 50px;
		align-items: center;
		justify-content: space-between;

		div {
			cursor: pointer;
		}

		.continueAdd {
			padding: 5px 10px;
			background: #fff;
		}

		.continueJoin {
			display: flex;
			align-items: center;
			background-color: rgb(240, 131, 39);
			height: 100%;

			.matching {
				color: rgb(131, 177, 230);
				margin-right: 50px;
			}

			.submit {
				height: 100%;
				background: rgba(240, 131, 39);
				line-height: 50px;
				padding: 0 30px;
				color: #fff;
			}
		}
		
		
		
	}
	.pupGoodsList {
		margin-top: 10px;
		height: 500px;
		overflow-y: scroll;
	
		.goodsSon {
			display: flex;
			align-items: flex-start;
			padding: 8px;
			border-bottom: 1px solid #ddd;
			background-color: #fff;
	
			input {
				display: inline-block;
				height: 22px;
				width: 22px;
				vertical-align: middle;
				margin: 0 3px;
				flex: 6;
				margin-top: 2px;
			}
	
			span {
				display: initial;
				height: auto;
				font-size: 16px;
				line-height: 28px;
				vertical-align: middle;
				flex: 94;
			}
		}
	
		.goodsSon:nth-of-type(odd) {
			background-color: #f9f9f9;
		}
	}
	.pagesRow{
		padding-top:20px;
		text-align: center;
	}
	.shopName {
		display: flex;
		align-items: center;
	
		.moreBn {
			font-size: 12px;
			color: #ff8000;
			display: block;
			white-space: nowrap;
			padding-left: 3px;
			cursor: pointer;
		}
	
		div {
			text-align: left;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/inquiry/index.vue